<div class=" card-wrapper">
  <form (ngSubmit)="onSubmit()" [formGroup]="applicationForm">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-9 col-lg-9 col-sm-12">
            <h3 class=" mb-0">Application Information</h3>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="p-2 mb-2">
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Budget
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': applicationForm.get('budget')?.invalid
                               && applicationForm.get('budget')?.touched }"
                         class="form-control"
                         formControlName="budget"
                         type="number" step="1"
                         [min]="amountRange.min" [max]="amountRange.max">
                  <div *ngIf="applicationForm.get('budget')?.invalid && applicationForm.get('budget')?.touched" class="invalid-feedback">
                    <div *ngIf="applicationForm.get('budget')?.hasError('required')">Budget is required.</div>
                    <div *ngIf="applicationForm.get('budget')?.hasError('wholeNumber')">Please enter a whole number (no decimals).</div>
                    <div *ngIf="applicationForm.get('budget')?.hasError('min')">Budget cannot be negative.</div>
                    <div *ngIf="applicationForm.get('budget')?.hasError('max')">Budget cannot exceed {{ amountRange.max | number }}.</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Currency
                </label>
                <div class="col-md-9">
                  <select [ngClass]="{ 'is-invalid': applicationForm.get('currencyId')?.invalid
                               && applicationForm.get('currencyId')?.touched }"
                          class="form-control"
                          formControlName="currencyId" id="currencyDdl">
                    <option *ngFor="let value of currency" [value]="value.id">{{ value.name }}</option>

                  </select>
                  <div class="invalid-feedback">
                    Currency is required.
                  </div>
                </div>
              </div>
            </div>


          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Country
                </label>
                <div class="col-md-9">
                  <select [ngClass]="{ 'is-invalid': applicationForm.get('countryId')?.invalid
                               && applicationForm.get('countryId')?.touched }"
                          class="form-control"
                          formControlName="countryId">
                    <option *ngFor="let value of countries" [value]="value.id">{{ value.name }}</option>

                  </select>
                  <div class="invalid-feedback">
                    Country is required.
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Location
                </label>
                <div class="col-md-9">
                  <input [ngClass]="{ 'is-invalid': applicationForm.get('location')?.invalid
                               && applicationForm.get('location')?.touched }" class="form-control"
                         formControlName="location"
                         type="text"
                         [maxlength]="limits.location">
                  <app-char-counter [control]="applicationForm.get('location')"
                                    [max]="limits.location"></app-char-counter>
                  <div class="invalid-feedback">
                    <div *ngIf="applicationForm.get('location')?.hasError('required')
                                || applicationForm.get('location')?.hasError('notBlank')">
                      Location is required.
                    </div>
                    <div *ngIf="applicationForm.get('location')?.hasError('maxlength')">
                      Location cannot exceed {{ limits.location }} characters.
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Start Date
                </label>
                <div class="col-md-9">
                  <input
                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"

                    [ngClass]="{
          'is-invalid': applicationForm.get('startDate')?.invalid &&
          applicationForm.get('startDate')?.touched
        }"
                    bsDatepicker
                    class="form-control"
                    formControlName="startDate"
                    placeholder="Select Start Date"
                    type="text"
                  />
                  <div class="invalid-feedback">
                    Start Date is required.
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  End Date
                </label>
                <div class="col-md-9">
                  <input
                    [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', showWeekNumbers: false }"
                    [ngClass]="{
          'is-invalid': (applicationForm.get('endDate')?.invalid &&
          applicationForm.get('endDate')?.touched) || applicationForm.hasError('invalidDateRange')
        }"
                    bsDatepicker
                    class="form-control"
                    formControlName="endDate"
                    placeholder="Select End Date"
                    type="text"
                  />
                  <div class="invalid-feedback">
                    End Date is required.
                  </div>
                  <div *ngIf="applicationForm.hasError('invalidDateRange')" class="invalid-feedback">
                    End Date cannot be earlier than Start Date.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">

            </div>
          </div>
          <div class="row" *ngIf="graintApplicationStatus == 'Approved'">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group row">
                <label class="col-md-3 col-form-label form-control-label">
                  Granted Amount
                </label>
                <div class="col-md-9">
                  <input
                    class="form-control"
                    formControlName="grantedAmount"
                    type="number"
                    readonly
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-control-label">
              Application Title
            </label>
            <p class="text-muted small" style="display: block">
              Please write the title in English and use no more than {{ limits.applicationName }} characters (spaces included)
            </p>
            <input [ngClass]="{ 'is-invalid': applicationForm.get('applicationName')?.invalid
                               && applicationForm.get('applicationName')?.touched }" class="form-control"
                   formControlName="applicationName"
                   type="text"
                   [maxlength]="limits.applicationName">
            <app-char-counter [control]="applicationForm.get('applicationName')"
                              [max]="limits.applicationName"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('applicationName')?.hasError('required')
                          || applicationForm.get('applicationName')?.hasError('notBlank')">
                Application Title is required.
              </div>
              <div *ngIf="applicationForm.get('applicationName')?.hasError('maxlength')">
                Application Title cannot exceed {{ limits.applicationName }} characters.
              </div>
              <div *ngIf="applicationForm.get('applicationName')?.hasError('englishOnly')">
                Application Title must contain only English characters and basic special characters (no other languages allowed).
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="form-control-label" style="display: block">
              Project Description (Max {{ limits.applicationDescription }} characters)
            </label>

            <p class="text-muted small" style="display: block">
              This will be used for specific purposes, such as NHC reporting back to donors.<br>
              Please answer the following questions:<br>
              Why is the initiative needed (overview of context/challenges)?<br>
              What is the objective of the project and the expected results (outcomes)?<br>
              How will the project address these challenges (overview of activities)?<br>
              Who will benefit (target group)?<br>
            </p>
            <textarea [ngClass]="{ 'is-invalid': applicationForm.get('applicationDescription')?.invalid
                               && applicationForm.get('applicationDescription')?.touched }"
                      class="form-control"
                      formControlName="applicationDescription" rows="7"></textarea>
            <app-char-counter [control]="applicationForm.get('applicationDescription')"
                              [max]="limits.applicationDescription"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('applicationDescription')?.hasError('required')
                          || applicationForm.get('applicationDescription')?.hasError('notBlank')">
                Application description is required.
              </div>
              <div *ngIf="applicationForm.get('applicationDescription')?.hasError('maxlength')">
                Project Description cannot exceed {{ limits.applicationDescription }} characters (a line break counts as two).
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-control-label" style="display: block">
              List of all ongoing projects (Max {{ limits.onGoingProject }} characters)
            </label>

            <p class="text-muted small" style="display: block">
              List of all ongoing grants/projects, including information on donor, project title, grant amount, support
              period,
              contact person and contact information (NHC might contact the contact persons for references).
            </p>
            <textarea [ngClass]="{ 'is-invalid': applicationForm.get('onGoingProject')?.invalid
                               && applicationForm.get('onGoingProject')?.touched }"
                      class="form-control"
                      formControlName="onGoingProject" rows="7"></textarea>
            <app-char-counter [control]="applicationForm.get('onGoingProject')"
                              [max]="limits.onGoingProject"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('onGoingProject')?.hasError('required')
                          || applicationForm.get('onGoingProject')?.hasError('notBlank')">
                List of all ongoing grants/projects is required.
              </div>
              <div *ngIf="applicationForm.get('onGoingProject')?.hasError('maxlength')">
                List of all ongoing projects cannot exceed {{ limits.onGoingProject }} characters (a line break counts as two).
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group ">
                <label class=" form-control-label">
                  Is this a continuation of an existing NHC project?
                </label>
                <select
                  [ngClass]="{ 'is-invalid': applicationForm.get('isContinueExistsProject')?.invalid
       && applicationForm.get('isContinueExistsProject')?.touched }"
                  class="form-control"
                  formControlName="isContinueExistsProject"
                >
                  <option [ngValue]="true">Yes</option>
                  <option [ngValue]="false">No</option>
                </select>

                <div class="invalid-feedback">
                  Continuation status is required.
                </div>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 col-sm-12">
              <div class="form-group">
                <label class="form-control-label">
                  Will this project be co-funded by other donors?
                </label>
                <select
                  [ngClass]="{ 'is-invalid': applicationForm.get('cofundStatusId')?.invalid
                               && applicationForm.get('cofundStatusId')?.touched }"
                  class="form-control"
                  formControlName="cofundStatusId"
                >
                  <option *ngFor="let value of cofundingStatus" [value]="value.id">{{ value.name }}</option>
                </select>
                <div class="invalid-feedback">
                  Co-fund status is required.
                </div>
              </div>
            </div>


          </div>


          <div *ngIf="applicationForm.get('cofundStatusId')?.value == 1" class="form-group">
            <label class="form-control-label" style="display: block">
              Co-funding details (Max {{ limits.cofundDescription }} characters)
            </label>
            <p class="text-muted small">Please list pending and/or successful applications to other donors here. If you
              have submitted this project to other donors, please state this here and indicate a) name of donor, b) what
              amount, and c) when you expect an answer. Please provide details under budget narrative below.
            </p>
            <textarea [ngClass]="{ 'is-invalid': applicationForm.get('cofundDescription')?.invalid
                               && applicationForm.get('cofundDescription')?.touched }"
                      class="form-control"
                      formControlName="cofundDescription" rows="7"></textarea>
            <app-char-counter [control]="applicationForm.get('cofundDescription')"
                              [max]="limits.cofundDescription"></app-char-counter>
            <div class="invalid-feedback">
              <div *ngIf="applicationForm.get('cofundDescription')?.hasError('required')
                          || applicationForm.get('cofundDescription')?.hasError('notBlank')">
                Co-fund detail is required.
              </div>
              <div *ngIf="applicationForm.get('cofundDescription')?.hasError('maxlength')">
                Co-funding details cannot exceed {{ limits.cofundDescription }} characters (a line break counts as two).
              </div>
            </div>
          </div>

          <div class="form-group">
            <label class="form-control-label">
              Impact
            </label>
            <p class="text-muted small">
              It is important for us to understand how your project is compatible with NHC’s main strategic
              directions. Therefore, we invite you to use one of these as the impact goal (overall goal) for
              your project.
            </p>
            <div dropdown class="dropdown-impact"
                 [ngClass]="{ 'is-invalid': applicationForm.get('impactId')?.invalid
                                          && applicationForm.get('impactId')?.touched }">
              <button dropdownToggle type="button"
                      class="form-control text-left d-flex justify-content-between align-items-center"
                      [ngClass]="{ 'is-invalid': applicationForm.get('impactId')?.invalid
                                               && applicationForm.get('impactId')?.touched }"
                      [disabled]="isReadOnly">
                <span class="impact-label">
                  {{ getImpactName(applicationForm.get('impactId')?.value) || 'Select impact' }}
                </span>
                <span class="caret"></span>
              </button>
              <ul *dropdownMenu class="dropdown-menu dropdown-menu-impact" role="menu">
                <li *ngFor="let value of impact" role="menuitem">
                  <a class="dropdown-item" (click)="selectImpact(value.id)">{{ value.name }}</a>
                </li>
              </ul>
            </div>
            <div class="invalid-feedback d-block"
                 *ngIf="applicationForm.get('impactId')?.invalid
                        && applicationForm.get('impactId')?.touched">
              Impact is required.
            </div>
          </div>

          <div class="form-group">
            <label class="form-control-label">Target Groups</label>
            <p class="small text-muted">Please select the group or groups that your project will address.</p>
            <select
              #selectTargetGroupElement
              [ngClass]="{ 'is-invalid': !isDraftMode && applicationForm.get('targetGroupId')?.invalid && applicationForm.get('targetGroupId')?.touched }"
              class="form-control"
              formControlName="targetGroupId"
              multiple

            >
              <option *ngFor="let value of targetGroups" [value]="value.id">{{ value.name }}</option>

              <option value="other">Other</option>

            </select>
            <div
              *ngIf="!isDraftMode && applicationForm.get('targetGroupId')?.invalid && applicationForm.get('targetGroupId')?.touched"
              class="invalid-feedback d-block"
            >
              Target Groups is required.
            </div>
          </div>
        </div>
        <div *ngIf="(applicationForm.get('targetGroupId')?.value).includes('other')" class="form-group">
          <label class="form-control-label">Specify Other Target Group</label>
          <input
            [ngClass]="{ 'is-invalid': applicationForm.get('targetGroupOther')?.invalid && applicationForm.get('targetGroupOther')?.touched }"
            class="form-control"
            formControlName="targetGroupOther"
            placeholder="Please specify the target group"
            type="text"
          />
          <div class="invalid-feedback">
            Please specify the "Other" target group.
          </div>
        </div>
        <div *ngIf="showMiniControl">
          <button class="btn btn-primary" type="submit" [disabled]="graintApplicationStatus == 'Approved' || this.isReadOnly">
            Submit
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="showMainControl" class="card">
      <div class="card-body">
        <button class="btn btn-primary" type="submit">Submit</button>
        <button class="btn btn-outline-primary" type="button" (click)="onSaveDraft()">Save Draft</button>
        <button [routerLink]="['/funding-opportunities']" class="btn btn-secondary" type="button">Back</button>
      </div>
    </div>

  </form>


</div>
